import React from "react";

import { Tab, Icon } from "@material-ui/core";

export default ({ icon, ...rest }) => {
	return <Tab icon={icon && <Icon>{icon}</Icon>} {...rest} />;
};
